import type { ProcessingTypeKey } from '../../Generated/ProcessingType.ts'
import { getProcessingTypeInlineBadgeStyle, getProcessingTypeLabel } from '../../Util/processingType.ts'

interface ProcessingTypeBadgeProps {
  processingType?: ProcessingTypeKey | null
  className?: string
}

export const ProcessingTypeBadge = ({ processingType, className = '' }: ProcessingTypeBadgeProps) => (
  <span className={`inline-flex items-center rounded px-2 py-1 text-xs font-semibold ${getProcessingTypeInlineBadgeStyle(processingType)} ${className}`}>
    {getProcessingTypeLabel(processingType)}
  </span>
)
